import CustomTable from "./CustomTable.js";

export default CustomTable;
